import React from 'react'
import { Grid } from "@mui/material";
import { Posts } from '../Posts';
import { PostType, TagType } from "../../../types";
import { useStyles } from "./RelatedPosts.styles";

interface RelatedPostsProps {
	posts: PostType[]
	tags?: TagType[]
}

export function RelatedPosts({ tags, posts }: RelatedPostsProps) {
	const { classes } = useStyles()

	return (
		<section className={classes.root}>
			<Grid container className={classes.container}>
				<Posts
					posts={posts || []}
					tags={tags || []}
					postsNumberDesktop={3}
					postsNumberMobile={2}
					showMoreButton
					rootClassName={classes.postsRoot}
					containerClassName={classes.postsContainer}
				/>
			</Grid>
		</section>
	)
}